import { AxiosInstance } from "axios";
import {
  GetVersionPayload,
  UpdateVersionPayload,
  VersionDto,
} from "../types/system/system";
import { ongBaseApi } from "./ong-base-api";
import { OngBaseResponse } from "./ong-base-response";

enum SystemApiUrl {
  VersionPut = "/setting/version",
  VersionGet = "/setting/version",
}

class SystemApi {
  private _api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this._api = api;
  }

  async updateVersion(
    payload: UpdateVersionPayload
  ): Promise<OngBaseResponse<null>> {
    return await this._api.put(SystemApiUrl.VersionPut, payload);
  }

  async getVersion(
    payload: GetVersionPayload
  ): Promise<OngBaseResponse<VersionDto>> {
    return await this._api.get(SystemApiUrl.VersionGet, { params: payload });
  }
}

export const systemApi = new SystemApi(ongBaseApi);
